<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">PROFIL INFRASTRUKTUR JAWA TENGAH</span>
                <span v-else>PROFIL INFRASTRUKTUR JAWA TENGAH</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Profil Infrastruktur Jawa Tengah</span>
                    <span v-else>Profil Infrastruktur Jawa Tengah</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
        <div class="container py-2">
            <div class="row">
                <div class="col-sm-4">
                    <label>Profil Infrastruktur</label>
                    <tree :config="config" :nodes="nodes" @nodeChecked="cek" @nodeUnchecked="uncek" @nodeFocus="cek">
                    </tree>
                </div>
                <div class="col-sm-8 text-center">
                    <div class="row">
                        <div class="col-sm-4">&nbsp;</div>
                        <div class="col-sm-4">
                            <label>Tahun</label>
                            <v-select :options="tahun" :reduce="(label) => label.code" label="label"
                                v-model="defaultSelectedtahun" @update:modelValue="ontahunChange"
                                style="background-color: #ffffff;"></v-select>
                        </div>
                        <div class="col-sm-4">&nbsp;</div>
                        <div class="col-sm-12">&nbsp;</div>
                        <div class="col-sm-12" v-if="datajumlahseries == 'radar'">
                            <RadarChartKerjasama type="radar" :options="chartOptions" :series="series" height="400">
                            </RadarChartKerjasama>
                        </div>
                        <div class="col-sm-12" v-else>
                            <BarChartKerjasama type="bar" :options="chartOptions" :series="series" height="400">
                            </BarChartKerjasama>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <span class="col-sm-8" v-html="konten" style="font-size: 11px;">
                    </span>
                </div>
            </div>
        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import { ref } from 'vue'
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-Regular, Arial, sans-serif" };

export default {
    components: {
        Top, Footer, swal, tree: treeview, RadarChartKerjasama: VueApexCharts, vSelect, BarChartKerjasama: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            showHuman: false,
            tampilmodal: localStorage.getItem("bookstamu"),
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            ipnya: '',
            datapesan: '',
            datamaster: [],
            nodes: {},
            config: {},
            series: [],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'radar',
                },
                dataLabels: {
                    enabled: true
                },
                plotOptions: {
                    radar: {
                        size: 140,
                        polygons: {
                            strokeColors: '#e9e9e9',
                            fill: {
                                colors: ['#f8f8f8', '#fff']
                            }
                        }
                    }
                },
                colors: ['#15B9D9'],
                markers: {
                    size: 4,
                    colors: ['#fff'],
                    strokeColor: '#15B9D9',
                    strokeWidth: 2,
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                xaxis: {
                    categories: [],
                    labels: {
                        style: {
                            colors: [],
                            fontSize: '12px',
                            fontWeight: 400,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    }
                },
                yaxis: {
                    tickAmount: 7,
                    labels: {
                        formatter: function (val, i) {
                            if (i % 2 === 0) {
                                return val
                            } else {
                                return ''
                            }
                        }
                    }
                }
            },
            tahun: [],
            datatahun: [],
            defaultSelectedtahun: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedtahun: '',
            selectedkodekab: '',
            selectedurusan: '',
            datajumlahseries: 'radar',
            konten: '',
        };
    },
    methods: {
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        async cekdisklaimer() {
            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        async ambildata() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovatioProfilSimfast-GetTreeProfil?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.nodes = '';
                        //this.nodes = this.datamaster;
                        var stringnode = '';
                        for (let i = 0; i < this.datamaster.length; i++) {
                            //alert(JSON.stringify(this.datamaster[i]));
                            var string = JSON.stringify(this.datamaster[i]);
                            var newString = string.indexOf('{') == 0 ? string.substring(1) : string;
                            newString = newString.replace(/.$/, "");
                            //alert(newString);
                            if (i == 0) {
                                stringnode = stringnode + newString;
                            }
                            else {
                                stringnode = stringnode + ',' + newString;
                            }

                            //this.nodes.push(this.datamaster[i]);
                        }
                        stringnode = "{" + stringnode + "}";
                        //alert(stringnode);
                        this.nodes = JSON.parse(stringnode);
                        this.config = {
                            roots: Response.data.content.root,
                            dragAndDrop: false,
                            checkboxes: false,
                            editable: false,
                            checkMode: 0,
                            openedIcon: {
                                type: "class",
                                class: "fas fa-folder-open",
                            },
                            closedIcon: {
                                type: "class",
                                class: "fas fa-folder",
                            },
                        };
                    }
                    else {
                        this.datamaster = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                //console.log(error);
                this.halamanloading = false;
            });
            await mainAPI2.get("parastapainnovatioProfilSimfast-GetProfilDaerah?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.series = [];
                    this.chartOptions = {
                        xaxis: {
                            categories: [],
                        },
                        title: {
                            text: '',
                            align: 'center',
                        },
                    };
                    this.series = [];
                    this.datajumlahseries = 'radar';
                    this.konten = '';
                    if (this.datapesan == 'data diketemukan') {
                        this.konten = atob(Response.data.content.konten);
                        this.datatahun = [];
                        this.tahun = [];
                        this.datatahun = Response.data.content.tahun;
                        var jumlahnya = Response.data.content.data.length;
                        if (jumlahnya > 2) {
                            this.datajumlahseries = 'radar';
                        }
                        else {
                            this.datajumlahseries = 'bar';
                        }
                        this.datatahun.forEach((item) => {
                            this.tahun.push({
                                label: item.tahun,
                                code: this.datatahun.indexOf(item),
                                tag: item.tahun,
                            });
                        });
                        this.defaultSelectedtahun = {
                            code: 0,
                            label: Response.data.content.maxtahun,
                            tag: Response.data.content.maxtahun,
                        };
                        this.selectedtahun = Response.data.content.maxtahun;
                        var arrayseries = [];
                        var arraynilai = [];
                        var dataseries = Response.data.content.data;
                        for (let i = 0; i < dataseries.length; i++) {
                            arrayseries.push(dataseries[i].text);
                            arraynilai.push(dataseries[i].nilai);
                        }
                        this.chartOptions = {
                            xaxis: {
                                categories: arrayseries,
                                labels: {
                                    style: {
                                        colors: ['#111', '#111', '#111', '#111', '#111', '#111', '#111', '#111', '#111'],
                                        fontSize: '10px',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-xaxis-label',
                                    },
                                }
                            },
                            title: {
                                text: Response.data.content.judul,
                                align: 'center',
                            },
                            dataLabels: {
                                enabled: true
                            },
                            plotOptions: {
                                radar: {
                                    size: 140,
                                    polygons: {
                                        strokeColors: '#e9e9e9',
                                        fill: {
                                            colors: ['#f8f8f8', '#fff']
                                        }
                                    }
                                }
                            },
                            colors: ['#15B9D9'],
                            markers: {
                                size: 4,
                                colors: ['#fff'],
                                strokeColor: '#15B9D9',
                                strokeWidth: 2,
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yaxis: {
                                tickAmount: 7,
                                labels: {
                                    formatter: function (val, i) {
                                        if (i % 2 === 0) {
                                            return val
                                        } else {
                                            return ''
                                        }
                                    }
                                }
                            }
                        };
                        this.series = [{
                            name: 'Nilai',
                            data: arraynilai,
                        }];
                    }
                    else {
                        this.datajumlahseries = 'radar';
                        this.konten = '';
                        this.datatahun = [];
                        this.tahun = [];
                        this.series = [];
                        this.chartOptions = {
                            xaxis: {
                                categories: [],
                            },
                            title: {
                                text: '',
                                align: 'center',
                            },
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datajumlahseries = 'radar';
                this.konten = '';
                this.datapesan = '';
                this.datatahun = [];
                this.tahun = [];
                this.series = [];
                this.chartOptions = {
                    xaxis: {
                        categories: [],
                    },
                    title: {
                        text: '',
                        align: 'center',
                    },
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
        async ambildataprofil() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovatioProfilSimfast-GetProfilDaerah?random=" + random + "&tahun=" + this.selectedtahun + "&kodekab=" + this.selectedkodekab + "&urusan=" + this.selectedurusan).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        var arrayseries = [];
                        var arraynilai = [];
                        var dataseries = Response.data.content.data;
                        this.datajumlahseries = 'radar';
                        this.konten = '';
                        this.konten = atob(Response.data.content.konten);
                        this.datajumlahseries = Response.data.content.data;
                        var jumlahnya = Response.data.content.data.length;
                        if (jumlahnya > 2) {
                            this.datajumlahseries = 'radar';
                        }
                        else {
                            this.datajumlahseries = 'bar';
                        }
                        for (let i = 0; i < dataseries.length; i++) {
                            arrayseries.push(dataseries[i].text);
                            arraynilai.push(dataseries[i].nilai);
                        }
                        this.chartOptions = {
                            xaxis: {
                                categories: arrayseries,
                                labels: {
                                    style: {
                                        colors: ['#111', '#111', '#111', '#111', '#111', '#111', '#111', '#111', '#111'],
                                        fontSize: '10px',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-xaxis-label',
                                    },
                                }
                            },
                            title: {
                                text: Response.data.content.judul,
                                align: 'center',
                            },
                            dataLabels: {
                                enabled: true
                            },
                            plotOptions: {
                                radar: {
                                    size: 140,
                                    polygons: {
                                        strokeColors: '#e9e9e9',
                                        fill: {
                                            colors: ['#f8f8f8', '#fff']
                                        }
                                    }
                                }
                            },
                            colors: ['#15B9D9'],
                            markers: {
                                size: 4,
                                colors: ['#fff'],
                                strokeColor: '#15B9D9',
                                strokeWidth: 2,
                            },
                            tooltip: {
                                y: {
                                    formatter: function (val) {
                                        return val
                                    }
                                }
                            },
                            yaxis: {
                                tickAmount: 7,
                                labels: {
                                    formatter: function (val, i) {
                                        if (i % 2 === 0) {
                                            return val
                                        } else {
                                            return ''
                                        }
                                    }
                                }
                            }
                        };
                        this.series = [{
                            name: 'Nilai',
                            data: arraynilai,
                        }];
                    }
                    else {
                        this.datajumlahseries = 'radar';
                        this.konten = '';
                        this.datatahun = [];
                        this.tahun = [];
                        this.series = [];
                        this.chartOptions = {
                            xaxis: {
                                categories: [],
                            },
                            title: {
                                text: '',
                                align: 'center',
                            },
                        };
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datajumlahseries = 'radar';
                this.konten = '';
                this.datapesan = '';
                this.datatahun = [];
                this.tahun = [];
                this.series = [];
                this.chartOptions = {
                    xaxis: {
                        categories: [],
                    },
                    title: {
                        text: '',
                        align: 'center',
                    },
                };
                //console.log(error);
                this.halamanloading = false;
            });
        },
        ontahunChange(a) {
            try {
                this.selectedtahun = this.tahun[a].tag;
            }
            catch (err) {
                return;
            }

            this.ambildataprofil();
        },
        cek(n) {
            if (n.children && n.children.length > 0) return;
            //alert(n.id);
            var temp = n.id.split("_");
            this.selectedkodekab = temp[1];
            this.selectedurusan = temp[2];
            this.ambildataprofil();
            //alert(this.selectedkodekab);
            //alert(this.selectedurusan);
        },
        uncek(n) {
            if (n.children && n.children.length > 0) return;
            // alert(n.id);
        }
    },
    mounted() {
        this.ambildata();
        this.cekdisklaimer();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>